import React from 'react';
import Modal from '../Modal';
import { maskEmail } from '../../util/helpers';
import styles from './styles.module.scss';

const SuccessModal = ({
    isOpen,
    onClose,
    userEmail,
    customMessage,
    property,
    title = 'Success!',
    ...props
}) => {
    const maskedEmail = userEmail ? maskEmail(userEmail) : null;

    const defaultMessage = maskedEmail
        ? `Your WiFi credentials for ${property.sitePage?.title} were sent to ${maskedEmail}.`
        : 'Your request has been submitted successfully.';

    return (
        <Modal
            expanded={true}
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            className="successModal"
            {...props}
        >
            <div className={styles.successContent}>
                <div className={styles.successIcon}>
                    <img src="/alert-success.svg" alt="Success" />
                </div>

                <div className={styles.message}>
                    <p className={styles.primaryMessage}>
                        {customMessage || defaultMessage}
                    </p>

                    <div className={styles.contactInfo}>
                        <p>
                            Please add email address{' '}
                            <strong>al.roberts@beachhousesinparadise.com</strong> to your
                            contacts to prevent the email from going to your junk/spam folder.
                        </p>
                    </div>
                </div>

                <div className={styles.actions}>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SuccessModal;
